module.exports = __webpack_public_path__ + "static/media/35.73de8041.jpg";